import { __rest } from "tslib";
import { createWidgetSettingsApi } from './settings';
export var createWidgetApi = function (baseUrl, http) {
    var url = "".concat(baseUrl, "/widgets");
    return {
        getWidget: function (widgetId) {
            return http.get("".concat(url, "/").concat(widgetId));
        },
        getWidgets: function () {
            return http.get("".concat(url));
        },
        getWidgetCostomCss: function (widgetId) {
            return http.get("".concat(url, "/").concat(widgetId, "/settings/advanced/css"))
                .then(function (res) { return res.content || ''; });
        },
        getWidgetCostomJs: function (widgetId) {
            return http.get("".concat(url, "/").concat(widgetId, "/settings/advanced/js"))
                .then(function (res) { return res.content || ''; });
        },
        updateWidgetChatSettings: function (dto) {
            var widgetId = dto.widgetId, requestDto = __rest(dto, ["widgetId"]);
            return http.put("".concat(url, "/").concat(widgetId, "/settings/modules/chat"), requestDto);
        },
        enableWidgetChatModule: function (widgetId) {
            return http.post("".concat(url, "/").concat(widgetId, "/settings/modules/chat/enable"), {});
        },
        disableWidgetChatModule: function (widgetId) {
            return http.post("".concat(url, "/").concat(widgetId, "/settings/modules/chat/disable"), {});
        },
        settings: createWidgetSettingsApi(baseUrl, http)
    };
};
export * from './settings';
//# sourceMappingURL=index.js.map